import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import PropTypes from 'prop-types';

import { Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';

const RawMaterialCreatesFollowUpsBySupplier = () => {

  let { id } = useParams();

  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");

useEffect(() => {
        setPermission(FindModuleById(448)); 
console.log(permission);

  axios
    .get(`/rawmaterials-boxes-groupby-supplier/${season_id+'__'+id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if (response.data.code === 200) {
       setValue(response.data.data.materials);
       setData(response.data.data.materials_all);
      }
    })
    .catch((error) => {
      console.log(error);
    });
}, [id]);




  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
   
  
  const LotNumberCell = ({ row }) => (
    <a href={`/raw-materials-view/${row.original.id}`} className="">
      {row.original.lot_number}
    </a>
  );
  
  const DifferenceCell = ({ row }) => (
    <span>{row.original.boxes_out - row.original.boxes_in}</span>
  );
  LotNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.number.isRequired,
        lot_number: PropTypes.string.isRequired,
      }),
    }).isRequired,
  };
  
  DifferenceCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        boxes_out: PropTypes.number.isRequired,
        boxes_in: PropTypes.number.isRequired,
      }),
    }).isRequired,
  };


const columns = [
  {
    accessorKey: 'plate_number',
    header: 'Plate Number',
  },
  {
    accessorKey: 'driver_name',
    header: 'Driver Name',
  },
  {
    accessorKey: 'shift_date',
    header: 'Shift Date',
  },
  // {
  //   header: 'Supplier',
  //   accessorFn: (row) => (row.supplier_name ? row.supplier_name.name : ""),
  // },
  {
    header: 'Lot Number',
    accessorFn: (row) => row.lot_number,
    Cell: LotNumberCell, // Use the extracted component
  },
  {
    accessorKey: 'boxes_out',
    header: 'Boxes OUT',
  },
  {
    accessorKey: 'boxes_in',
    header: 'Boxes IN',
  },
  {
    header: 'Difference',
    Cell: DifferenceCell, // Use the extracted component
  },
];



  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Crates Follow Up grup By  Supplier </h3>
                  <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/crates-follow-up">Crates Follow Up</Link>
                    </li>
                    <li className="breadcrumb-item active">Crates Follow Up grup By  Supplier</li>
                  </ul>
                </div>
               
              </div>
            </div>
         
               
          
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Crates Follow Up grup By  Supplier</h4>
                      <table className="table table-bordered">
                      <tr>
                          <th className="p-3">Supplier</th>
                          <td className="p-3">
                          {value.supplier ? value.supplier : ''}


                          </td>
                        </tr>
                       
                        <tr>
                          <th className="p-3">Total Boxes OUT</th>
                          <td className="p-3">{value.total_boxes_out}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Total Boxes IN</th>
                          <td className="p-3">{value.total_boxes_in}</td>
                        </tr>
                        <tr>
                          <th className="p-3"> Difference</th>
                          <td className="p-3">{(value.difference)}</td>
                        </tr>
                        <tr>
                          <th className="p-3"> Total Entries</th>
                          <td className="p-3">{value.total_entries}</td>
                        </tr>
                     
                     
                       
                      </table>
                  </div>
                </div>
              </div>
            </div>
         

            <div className="row">
              <div className="col-sm-12">
              <section className="comp-section">
                <div className="row">
              
                <div className="col-md-12">
                <div className="table-responsive">
                                  <MaterialReactTable columns={columns} data={data} 
                                      enableColumnOrdering
                                      enablePinning
                                     
                                    />
                                 
                                  </div>
                </div>
                </div>
            </section>

              </div>
            </div>

            
          </div>
       

        </div>
      </div>
    </>
  );
};
export default RawMaterialCreatesFollowUpsBySupplier;
